import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class auditService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };
  
  getAuditData = (params) => {
    return AxiosService.Get(`api/cam/srm/audit-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };
}